import { render, staticRenderFns } from "./FerramentasSentinelHub.vue?vue&type=template&id=50fbc60f&lang=pug"
import script from "./FerramentasSentinelHub.vue?vue&type=script&lang=js"
export * from "./FerramentasSentinelHub.vue?vue&type=script&lang=js"
import style0 from "./FerramentasSentinelHub.vue?vue&type=style&index=0&id=50fbc60f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports